import { render, staticRenderFns } from "./FIBSlider.vue?vue&type=template&id=ed06e28c&"
import script from "./FIBSlider.vue?vue&type=script&lang=js&"
export * from "./FIBSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSlider});
